/**
 * The normal application uses the real Django service. The in-memory prototype is available only when explicitly requested
 * with VITE_API_MODE=mock by development/test tooling; a missing setting never switches the user onto sample data.
 */
export const apiMode: 'mock' | 'live' = import.meta.env.VITE_API_MODE === 'mock' ? 'mock' : 'live';
